import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSpring, animated, config } from 'react-spring';

const DropDownAcademics = () => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef();

  // Handle mouse enter: show dropdown
  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setIsOpen(true);
  };

  // Handle mouse leave: hide dropdown after delay
  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  // Clear timeout on unmount
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  // Animation for dropdown
  const fadeInOut = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: `scaleY(${isOpen ? 1 : 0.8})`,
    config: config.default,
    delay: isOpen ? 0 : 200,
  });

  // Download main academic calendar
  const handleCalendarClick = () => {
    const calendarPath = `${process.env.PUBLIC_URL}/assets/Calendar.pdf`;
    const link = document.createElement('a');
    link.href = calendarPath;
    link.setAttribute('download', 'Calendar.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  // Download holiday calendar
  const handleHolidayCalendarClick = () => {
    const holidayPath = `${process.env.PUBLIC_URL}/assets/HolidayCalendar.pdf`;
    const link = document.createElement('a');
    link.href = holidayPath;
    link.setAttribute('download', 'HolidayCalendar.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div
      className="relative group"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Menu Title */}
      <div className="text-amber-300 text-lg font-normal font-['DM Sans'] capitalize tracking-wide group-hover:text-amber-500 cursor-pointer">
        Academics
      </div>

      {/* Dropdown Items */}
      {isOpen && (
        <animated.div
          style={fadeInOut}
          className="absolute top-full left-0 bg-white text-gray-800 shadow-md p-2 mt-2 rounded-md border border-gray-200 flex flex-col z-10"
        >
          <NavLink text="Faculty" to="/FacultyPage" />

          <div
            className="text-gray-800 text-sm p-2 hover:text-blue-500 cursor-pointer block whitespace-nowrap transition-colors duration-300"
            onClick={handleCalendarClick}
          >
            Calendar
          </div>

          <div
            className="text-gray-800 text-sm p-2 hover:text-blue-500 cursor-pointer block whitespace-nowrap transition-colors duration-300"
            onClick={handleHolidayCalendarClick}
          >
            Holiday Calendar
          </div>

          {/* <NavLink text="Syllabus" to="/SyllabusPage" /> */}
        </animated.div>
      )}
    </div>
  );
};

// Reusable navigation link
const NavLink = ({ text, to }) => (
  <Link
    to={to}
    className="text-gray-800 text-sm p-2 hover:text-blue-500 cursor-pointer block whitespace-nowrap transition-colors duration-300"
  >
    {text}
  </Link>
);

export default DropDownAcademics;
